import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-abouttext',
  templateUrl: './abouttext.component.html',
  styleUrls: ['./abouttext.component.css']
})
export class AbouttextComponent implements OnInit {

  constructor() { }
  aboutgrid = [
    {icon:'assets/images/icon/icon-4.png',title:'Valuable Insight',text:'BSides Bangalore presents technical security talks, technical hands-on workshops, CTF and other interesting knowledge gaining events on cutting edge security technologies, with the very latest security research, development and trends..!'},
    {icon:'assets/images/icon/icon-5.png',title:'Global Audience',text:'BSides Bangalore strives to bring together the best minds in the industry. It encourages and inspires professionals at all career levels globally to join us and collaborate and network with world-class security researchers, and leaders in the public and private sectors.'},
    {icon:'assets/images/icon/icon-6.png',title:'Sponsor Spotlight',text:'BSides Bangalore takes pride in recognizing our sponsors and partners who support us positively to the growth of BSides Bangalore. This event provides unique opportunities for community engagement between vendors and attendees.'},
  ];

  ngOnInit(): void {
  }

}
